let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1L20F")).then(() => parcelRequire('6FVgS'));